export const ACCOUNT_SUBJECT_REVIEW_CLASSES = [
  "records.NovaAutomation",
  "records.NovaAutomationVersion",
  "records.NovaTrigger",
  "records.NovaStep",
  "records.NovaRun",
  "records.NovaAuditLog",
  "records.NovaWebhookSubscription",
  "records.Episode",
  "records.SemanticFact",
  "records.GraphNode",
  "records.GraphEdge",
  "records.KnowledgeAsset",
  "records.AgentArtifact",
  "records.ArtifactVersion",
  "records.PublishedSite",
  "records.JobApplication",
  "records.TalentNetworkSubmission",
  "records.SubmissionReceipt",
  "records.ApplicationStudioProject",
  "records.ApplicationStudioArtifact",
  "records.MastraThreads",
  "records.MastraMessages",
  "records.MastraWorkingMemory",
  "records.CV",
  "records.CVLanguageVariant",
  "records.CvRevisionContent",
  "records.CvApprovedRelease",
  "records.CvEditionSourceRevision",
  "records.CvEditionRevision",
  "records.CvTranslationProposal",
  "records.CvImportEvidence",
] as const;
export type AccountSubjectReviewClass =
  (typeof ACCOUNT_SUBJECT_REVIEW_CLASSES)[number];
export type AccountSubjectReviewStatus =
  | "pending"
  | "needs_evidence"
  | "approved_personal"
  | "denied"
  | "stale";
export interface AccountSubjectReviewDescriptor {
  sourceClass: AccountSubjectReviewClass;
  keys: string[];
  fields: string[];
  contentFingerprint: string;
  scopeFingerprint: string;
}
export interface AccountSubjectReviewItem extends AccountSubjectReviewDescriptor {
  id: string;
  status: AccountSubjectReviewStatus;
  statement: string;
  reason: string | null;
  createdAt: string;
  updatedAt: string;
}
export interface AccountSubjectReviewPage {
  items: AccountSubjectReviewItem[];
  next: string | null;
  enabled: boolean;
}
